<template>
  <main id="single-material" class="section">
    <template v-if="post">
      <h2 class="title is-2">{{ post.title.rendered }}</h2>

      <figure v-if="!post.children.length" class="image">
        <img :src="thumb" :alt="post.title.rendered">
      </figure>

      <div class="content post-contents" v-html="post.content.rendered"></div>

      <div v-if="post.children.length">
        <div class="columns is-multiline">
          <div class="column is-3" v-for="child in post.children" :key="child.id">
            <!-- {{child}} -->
            <material :post="child"></material>
          </div>
        </div>
      </div>
      <div v-else class="form download">
        <h3 class="title is-4">ダウンロード</h3>

        <div class="field has-addons has-addons-centered">

          <div class="control">
            <a class="button" :href="png" :download="this.post.slug + '.png'">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>PNG</span>
            </a>
          </div>
          <div class="control">
            <a class="button" :href="jpg" :download="this.post.slug + '.jpg'">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>JPG</span>
            </a>
          </div>
          <div class="control">
            <a class="button" :href="gif" :download="this.post.slug + '.gif'">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>GIF</span>
            </a>
          </div>
        </div>
        <div class="field has-addons has-addons-centered">
          <div class="control">
            <a class="button" :href="svg">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>SVG</span>
            </a>
          </div>
          <div class="control">
            <a class="button" :href="ai">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>AI</span>
            </a>
          </div>
          <div class="control">
            <a class="button" :href="eps">
              <span class="icon is-small">
                <i></i>
              </span>
              <span>EPS</span>
            </a>
          </div>
        </div>
      </div>

    </template>
    <Loader v-else />
  </main>
</template>

<script>
  import Material from "../partials/Material.vue";
  import axios from "axios";
  import Loader from "../partials/Loader.vue";
  import {
    mapGetters
  } from "vuex";
  import SETTINGS from "../../settings";

  // let base_path = process.env.VUE_APP_MATERIAL_URL_BASE;
  // let dl_path = process.env.VUE_APP_MATERIAL_URL_DOWNLOAD;

  const file_exts = ["png", "jpg", "gif", "svg", "eps", "ai"];

  // this.title = head.title;
  // this.meta = head.meta;
  export default {
    data() {
      let head = this.getHeadMetaFromPost(null);
      return {
        post: false,
        thumb: null,
        file_exts: file_exts,
        //seo
        title: head.title,
        link: head.link,
        meta: head.meta,
        // dl: {}
        is_search_pid: false
      };
    },
    // head() {
    //   return this.post ? this.getHeadMetaFromPost(this.post) : {};
    //   // return null;
    // },
    head: {
      title: function () {
        return this.title
      },
      link: function () {
        return this.link
      },
      meta: function () {
        return this.meta
      },
      // meta() {
      //   return [{
      //     name: 'og:foo',
      //     content: this.x
      //   }, ];
      // },
    },
    // updated() {
    //   this.$emit('updateHead');
    // },
    computed: {},

    beforeMount() {
      this.getPost();
    },
    mounted() {

    },
    watch: {
      '$route'() {
        console.log("change material slug");
        if (this.is_search_pid) {
          //pid から slug への変更時は データ取得を行わない
          this.is_search_pid = false;
        } else {
          this.getPost();
        }
      },
    },
    methods: {
      // download(file, event) {
      //   console.log(file);
      //   axios({
      //       method: 'post',
      //       url: file,
      //       responseType: 'arraybuffer',
      //       // data: dates
      //     })
      //     .then(function (response) {
      //       let blob = new Blob([response.data], {
      //         // type: 'application/pdf'
      //       })
      //       let link = document.createElement('a')
      //       link.href = window.URL.createObjectURL(blob)
      //       link.download = 'Report.pdf'
      //       link.click()
      //     });
      //   return false;
      //   // var csv = '\ufeff' + '品名,価格\n'
      //   // this.items.forEach(el => {
      //   //   var line = el['name'] + ',' + el['price'] + '\n'
      //   //   csv += line
      //   // })
      //   // let blob = new Blob([csv], {
      //   //   type: 'text/csv'
      //   // })
      //   // let link = document.createElement('a')
      //   // link.href = window.URL.createObjectURL(blob)
      //   // link.download = 'Result.csv'
      //   // link.click()
      // },

      getDownloadUrl(ext) {
        return this.getMaterialDLUrl(this.post.slug + '.' + ext);
      },
      getImageUrl(ext) {
        return this.getMaterialUrl(this.post.slug + '.' + ext);
      },
      createMaterialSlug(post) {
        let link = post.link;
        let nohost = link.split('//')[1];
        let slugs = nohost.split("/");
        slugs.shift();
        let slug = slugs.join('/');
        // console.log(slug);
        post.path = '/' + slug;
        return post;
      },
      getPost: function () {
        // console.log("this.$route.params.postSlug", this.$route.params);

        let target;

        let p = this.$route.query.p;
        let postSlug = this.$route.params.postSlug;

        if ($.isNumeric(postSlug)) {
          //数値のみならID扱い
          p = postSlug;
        }
        // let is_search_pid = false;
        if (p) {
          //ページID
          target = SETTINGS.API_BASE_PATH + "material/" + p;
          this.is_search_pid = true;
        } else {
          target = SETTINGS.API_BASE_PATH + "material?slug=" + postSlug;
        }
        console.log(target);

        axios
          .get(
            target
          )
          .then(response => {
            if (this.is_search_pid) {
              this.post = response.data;
              //ルート変更
              this.$router.push({
                name: 'Material',
                params: {
                  postSlug: this.post.slug
                }
              })
            } else {
              this.post = response.data[0];
            }
            console.log("this.post", this.post);
            this.thumb = this.getImageUrl("svg");

            file_exts.map((ext) => {
              //this.png
              this[ext] = this.getDownloadUrl(ext);
            })
            // console.log(this.dl);

            this.post.children.map((child, j) => {
              this.post.children[j] = this.createMaterialSlug(child);
            })
            // vue head
            let head = this.getHeadMetaFromPost(this.post, "article");
            // console.log(head);
            this.title = head.title;
            this.meta = head.meta;
            this.link = head.link;
            this.$emit('updateHead');
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    components: {
      Loader,
      Material
    }
  };
</script>